.wrapper {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.recommenderMain {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  padding: var(--space-10) var(--page-padding-x) var(--space-12);
}

.recommenderLayout {
  max-width: var(--page-max-width);
  margin: 0 auto;
  display: flex;
  gap: 3.5rem;
  align-items: start;
}

.mainContainer {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 5rem;
}

.content {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  margin-left: 2rem;
  margin-top: 2rem;
}
